import { hexToRGBA } from '@/config/settings';

import type { ChartTheme } from '../theme';

import type { MetricSeriesSpec } from './seriesTypes';

function liftAll(colors: (string | undefined)[], theme: ChartTheme): (string | undefined)[] {
    return colors.map((color) => (color === undefined ? undefined : theme.color(color)));
}

/**
 * `series` with every colour it names as `theme` draws it. Specs keep naming the light
 * palette colours; this is the one place a series is switched to its dark lift, so the plot,
 * the tooltip swatch and the legend dot all agree. Lifting an already lifted colour leaves
 * it as it is. A series `opacity` is applied after the lift.
 */
export function themedSeries(series: MetricSeriesSpec, theme: ChartTheme): MetricSeriesSpec {
    const lifted = theme.color(series.color);
    return {
        ...series,
        color: series.opacity === undefined ? lifted : hexToRGBA(lifted, series.opacity),
        ...(series.barColors ? { barColors: liftAll(series.barColors, theme) } : {}),
        ...(series.barBorder
            ? {
                  barBorder: {
                      ...series.barBorder,
                      color:
                          series.barBorder.color === undefined
                              ? theme.surface
                              : theme.color(series.barBorder.color),
                  },
              }
            : {}),
        ...(series.barOutlines
            ? {
                  barOutlines: {
                      ...series.barOutlines,
                      colors: liftAll(series.barOutlines.colors, theme),
                  },
              }
            : {}),
    };
}
